/**
 * toolContracts.js — Tool schema type definitions.
 *
 * Every tool in the Kevia orchestration layer must conform to this contract.
 * The contract is purely descriptive — no execution happens here.
 *
 * Architectural boundary:
 *
 *  Cognition  → "what does Kevia believe should happen?"
 *  (runtimeSelectors, signals, intent)
 *
 *  Orchestration → "which tool is appropriate?" (this layer)
 *  (toolRegistry, resolveToolIntent, executionPolicy)
 *
 *  Execution → "the real action"
 *  (NOT implemented — approval-gated, future layer)
 *
 * @typedef {Object} ToolContract
 * @property {string}                id                  — unique stable identifier
 * @property {string}                label               — human-readable name
 * @property {string}                description         — what this tool does
 * @property {string[]}              allowedRoles        — "*" | "admin" | "coordinator" | "pastor"
 * @property {boolean}               requiresConfirmation
 * @property {"low"|"medium"|"high"} riskLevel
 * @property {string[]}              supportedModes      — OPERATIONAL_MODES keys
 * @property {boolean}               offlineCompatible
 * @property {string}                target              — route path or action identifier
 */

export const TOOL_RISK = Object.freeze({
  LOW:    "low",
  MEDIUM: "medium",
  HIGH:   "high",
});
